import { container, title } from "assets/jss/material-kit-react.jsx";

const ctaSectionStyle = {
  containerParent: {
    maxHeight: "100%",
    overflow: "hidden",
    position: "relative",
    margin: "0",
    padding: "60px 0px 100px 0px",
    border: "0",
    display: "flex",
    alignItems: "center",
    background: "transparent",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    "&:after,&:before": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''"
    }
  },
  filterLight: {
    "&:before": {
      background: "rgba(0, 0, 0, 0.2)"
    }
  },
  filterMedium: {
    "&:before": {
      background: "rgba(0, 0, 0, 0.3)"
    }
  },
  filterDark: {
    "&:before": {
      background: "rgba(0, 0, 0, 0.4)"
    }
  },
  filterExtraDark: {
    "&:before": {
      background: "rgba(0, 0, 0, 0.5)"
    }
  },
  container: {
    ...container,
    zIndex: "12",
    color: "#f8f8ff",
    marginLeft: "auto",
    paddingTop: "50px",
    paddingLeft: "15px",
    marginRight: "auto",
    paddingRight: "15px",
    "&:before": {
      background: "linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 1))",
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "30%",
      display: "block",
      content: "''",
      top: "0",
      left: "0"
    },
  },
  gridContainerItem: {
    textShadow: "1px 1px 2px black",
    width: "100%",
    zIndex: "24",
    // // with border
    padding: "30px",
    borderWidth: "4px",
    borderRadius: "6px",
    borderColor: "white",
    borderStyle: "solid",
    boxShadow: "1px 1px 1px black"
  },
  inlineBlock: {
    display: "inline-block",
  },
  title: {
    ...title,
    fontSize: "3.3125rem",
    fontWeight: "700",
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    color: "#f8f8ff",
    textDecoration: "none",
    lineHeight: "1.33em"
  },
  subtitle: {
    fontSize: "1.5rem",
    fontWeight: "700",
    maxWidth: "500px",
    margin: "0px",
  },
  text: {
    fontSize: "1rem",
    "@media (min-width: 576px)": {
    },
    "@media (min-width: 768px)": {
      fontSize: "1.125rem",
    }
  },
};

export default ctaSectionStyle;